<button class="boton-filtro todos"
        (click)="clearFilters()">TODOS
</button>
<div class="custom-filtering-buttons" *ngFor="let customFilteringButton of customFilteringButtons; let i = index;">
    <button [class]="customFilteringButton.class + (filterCompare(selected, customFilteringButton.filter) ? '-selected' : '')"
            (click)="filterChange(customFilteringButton.filter)">{{ customFilteringButton.text }}
    </button>
</div>
